import { PERMISSION_LEVEL } from "@constants/permissionLevel";
import Spinner from "@legacy/core/components/Spinner";
import { AccessCheck, Bullet } from "@particles/index";
import { Component } from "react";
import UniversalButton from "../buttons/UniversalButton";
import { formatCurrencyForServiceCompany, formatLocalTime } from "../utils/utils";


class CreditAllocationList extends Component {

    constructor() {
        super()

        this.state = {
            allocations: null,
        }
    }

    fetchAllocations = async () => {
        const response = await fetch(this.props.endpoint)
        return await response.json()
    }

    componentDidMount = async () => {
        if (this.props.object.id !== undefined) {
            const allocationsList = await this.fetchAllocations()
            this.setState({ allocations: allocationsList })
        }
        else {
            this.setState({ allocations: [] })
        }
    }

    render = () => {
        const { object, isReversing, onReverse } = this.props

        if (this.state.allocations === null) {
            return (
                <div className="data-panel__form__field__display-list">
                    <Spinner centered={true} />
                </div>
            )
        }

        return (
            <div className="data-panel__form__field__display-list" aria-label="Credit Allocation List">
                {this.state.allocations.map(
                    (allocation) => {
                        return (
                            <div key={allocation.id} className="data-panel__form__field__display-list__object payment-display" aria-label="Credit Allocation">
                                <div className="payment-display__row">
                                    <div className="payment-display__field" aria-label="Credit Note">
                                        <div className="payment-display__field-label" aria-hidden="true">Credit Note</div>
                                        <div className="payment-display__field-value">
                                            <a href={DjangoUrls["invoices:credit-notes-detail"](window.MARKETPLACE_ENTITY_SLUG, allocation.credit_note_id)}>
                                                {allocation.credit_note_custom_id || allocation.credit_note_id}
                                            </a>
                                        </div>
                                    </div>
                                    <div className="payment-display__field" aria-label="Date Applied">
                                        <div className="payment-display__field-label" aria-hidden="true">Date Applied</div>
                                        <div className="payment-display__field-value" aria-label="Date Applied">
                                            {formatLocalTime(allocation.created_at, object.service_company.preferred_timezone, true, false, false, true).localDateString}
                                        </div>
                                    </div>
                                    <div className="payment-display__field" aria-label="Amount">
                                        <div className="payment-display__field-label" aria-hidden="true">Amount</div>
                                        <div className="payment-display__field-value" aria-label="Amount">
                                            {formatCurrencyForServiceCompany(allocation.amount * -1, object.service_company)}
                                        </div>
                                    </div>
                                </div>
                                {allocation.quickbooks_desktop_removal_requested_at ? (
                                    <div className="payment-display__row credit-allocation-reverse-row">
                                        <span className="credit-allocation-reverse-row__pending" aria-label="Reversal Requested">
                                            Reversal requested {formatLocalTime(allocation.quickbooks_desktop_removal_requested_at, object.service_company.preferred_timezone, true, false, false, true).localDateString}
                                            <Bullet />
                                            Waiting for QuickBooks Desktop
                                        </span>
                                    </div>
                                ) : (
                                    <AccessCheck permissions={{
                                        invoices_delete_permission: PERMISSION_LEVEL.FULL
                                    }}>
                                        <div className="payment-display__row credit-allocation-reverse-row">
                                            <UniversalButton type="danger" text="Reverse" disabled={isReversing} handler={() => onReverse(allocation)} />
                                        </div>
                                    </AccessCheck>
                                )}
                            </div>
                        )
                    }
                )}
            </div>
        )
    }
}

export default CreditAllocationList;
